// Generated by purs version 0.15.12
import * as $foreign from "./foreign.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Reflectable from "../Data.Reflectable/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_String_NonEmpty_Internal from "../Data.String.NonEmpty.Internal/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var fromJust = /* #__PURE__ */ Data_Maybe.fromJust();
var toString = /* #__PURE__ */ $foreign.toBase(10);
var toInt = function ($12) {
    return Data_Int.fromNumber($foreign.toNumber($12));
};
var toBase$prime = function (i) {
    return function (bi) {
        return fromJust(Data_String_NonEmpty_Internal.fromString($foreign.toBase(i)(bi)));
    };
};
var toNonEmptyString = /* #__PURE__ */ toBase$prime(10);
var showBigInt = {
    show: function (x) {
        return "(fromString \"" + (toString(x) + "\")");
    }
};
var semiringBigInt = {
    add: $foreign.biAdd,
    zero: /* #__PURE__ */ $foreign.fromInt(0),
    mul: $foreign.biMul,
    one: /* #__PURE__ */ $foreign.fromInt(1)
};
var add = /* #__PURE__ */ Data_Semiring.add(semiringBigInt);
var ringBigInt = {
    sub: $foreign.biSub,
    Semiring0: function () {
        return semiringBigInt;
    }
};
var sub = /* #__PURE__ */ Data_Ring.sub(ringBigInt);
var rem = $foreign.biMod;
var quot = $foreign.biDiv;
var fromTLInt = function () {
    return function (dictReflectable) {
        var reflectType = Data_Reflectable.reflectType(dictReflectable);
        return function (v) {
            return $foreign.fromTypeLevelInt(reflectType(Type_Proxy["Proxy"].value));
        };
    };
};
var fromNumber = /* #__PURE__ */ (function () {
    return $foreign.fromNumberImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
})();
var fromBase = /* #__PURE__ */ (function () {
    return $foreign.fromBaseImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
})();
var fromString = /* #__PURE__ */ fromBase(10);
var eqBigInt = {
    eq: $foreign.biEquals
};
var ordBigInt = {
    compare: function (x) {
        return function (y) {
            var v = $foreign.biCompare(x)(y);
            if (v === 1) {
                return Data_Ordering.GT.value;
            };
            if (v === 0) {
                return Data_Ordering.EQ.value;
            };
            return Data_Ordering.LT.value;
        };
    },
    Eq0: function () {
        return eqBigInt;
    }
};
var commutativeRingBigInt = {
    Ring0: function () {
        return ringBigInt;
    }
};
var euclideanRingBigInt = {
    div: function (x) {
        return function (y) {
            return $foreign.biDiv(sub(x)(Data_EuclideanRing.mod(euclideanRingBigInt)(x)(y)))(y);
        };
    },
    mod: function (x) {
        return function (y) {
            var yy = $foreign.abs(y);
            return $foreign.biMod(add($foreign.biMod(x)(yy))(yy))(yy);
        };
    },
    degree: function ($13) {
        return Data_Int.floor($foreign.toNumber($foreign.abs($13)));
    },
    CommutativeRing0: function () {
        return commutativeRingBigInt;
    }
};
export {
    fromInt,
    toBase,
    digitsInBase,
    abs,
    even,
    odd,
    prime,
    pow,
    not,
    or,
    xor,
    and,
    shl,
    shr,
    toNumber
} from "./foreign.js";
export {
    fromString,
    fromBase,
    fromNumber,
    fromTLInt,
    toString,
    toNonEmptyString,
    toBase$prime,
    quot,
    rem,
    toInt,
    eqBigInt,
    ordBigInt,
    showBigInt,
    semiringBigInt,
    ringBigInt,
    commutativeRingBigInt,
    euclideanRingBigInt
};
